export default {"src":"/_next/static/media/black-entry-point.d3240123.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};